import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetPharmaBlockedAlternativeText = (
  product: PimProductV11,
): boolean | string => {
  return product.pharma_blocked_alternative_text ?? false
}
